module.exports = __webpack_public_path__ + "img/usa-flag.e0d637cf.png";